"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = _interopRequireDefault(require("../../../Buttons/IconButton"));

var _ParagraphText = _interopRequireDefault(require("../../BasicTextElements/ParagraphText"));

var _PrimaryText = _interopRequireDefault(require("../../BasicTextElements/PrimaryText"));

var _ConfirmDetails = require("./ConfirmDetails.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ConfirmDetails = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ConfirmDetails, _React$PureComponent);

  var _super = _createSuper(ConfirmDetails);

  function ConfirmDetails() {
    var _this;

    _classCallCheck(this, ConfirmDetails);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderParagraphtext", function () {
      var bodyText = _this.props.bodyText;
      return bodyText.map(function (text, i) {
        return /*#__PURE__*/_react.default.createElement(_ParagraphText.default, {
          key: text,
          dataTestId: "contact-details-display-email-text-".concat(i)
        }, text);
      });
    });

    return _this;
  }

  _createClass(ConfirmDetails, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          _inStyleGuide = _this$props._inStyleGuide,
          className = _this$props.className,
          editHandler = _this$props.editHandler,
          headerText = _this$props.headerText;
      var paragraphText = this.renderParagraphtext();
      return /*#__PURE__*/_react.default.createElement(_ConfirmDetails.StyledConfirmDetailsContainer, {
        _inStyleGuide: _inStyleGuide,
        className: className,
        "data-test-id": "contact-details-display"
      }, /*#__PURE__*/_react.default.createElement(_ConfirmDetails.StyledDetailsBlock, null, headerText && /*#__PURE__*/_react.default.createElement(_PrimaryText.default, {
        dataTestId: "contact-details-display-name-text"
      }, headerText), paragraphText), /*#__PURE__*/_react.default.createElement(_ConfirmDetails.StyledButtonContainer, null, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
        dataTestId: "contact-details-display-edit-button",
        iconName: "pencil-alt",
        onClick: editHandler
      })));
    }
  }]);

  return ConfirmDetails;
}(_react.default.PureComponent);

_defineProperty(ConfirmDetails, "propTypes", {
  /** Styleguide override */
  _inStyleGuide: _propTypes.default.bool,

  /** Value for text body */
  bodyText: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.string]),

  /** Styling classname */
  className: _propTypes.default.string,

  /** Hoisting function for an edit action */
  editHandler: _propTypes.default.func.isRequired,

  /** Value for the header */
  headerText: _propTypes.default.string
});

_defineProperty(ConfirmDetails, "defaultProps", {
  _inStyleGuide: false,
  bodyText: [],
  className: '',
  headerText: undefined
});

var _default = ConfirmDetails;
exports.default = _default;